import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-99eb877e")

_pushScopeId("data-v-99eb877e")
const _hoisted_1 = { class: "register-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Reset Password", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Reset")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_grid, { class: "register-sign-in no-pad" }, {
        default: _withId(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeMd: "6",
                sizeSm: "12"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                      class: "sign-in-input",
                      type: "email",
                      placeholder: "Email"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ion_button, {
                      color: "success",
                      onClick: _ctx.sendResetLink,
                      disabled: _ctx.loading
                    }, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "full-bg mobile-none",
                sizeMd: "6",
                sizeXs: "0"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})